import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ViewPage from '../2/Controls/ViewPage';
import Icon from '../2/Controls/Icon';
import SideBySideLayout from '../2/Controls/SideBySideLayout';
import { NO_IMAGE_FOUND } from '../../actions/Util';
import CustomTable from '../2/Controls/CustomTable';
import NewAuditTrail from '../2/Controls/NewAuditTrail';

class MachineTrackerLedger extends Component {
    constructor() {
        super()
        this.state = {
            ledgerData: [],
            machineData: {},
            machineServices:[],
            loading: true,
            servicesLoading:true,
        }
        this.loadLedgerData = this.loadLedgerData.bind(this)
        this.handleRemoveClick = this.handleRemoveClick.bind(this)
    }

    componentDidMount() {
        this.loadLedgerData()
    }

    loadLedgerData() {
        const { data } = this.props;

        this.setState({
            loading: true,
            servicesLoading:true,
            machineData: data || {}
        })

            this.props.getMachineLedger(data.key).then((result) => {
                this.setState({
                    ledgerData: result,
                    loading: false,
                })
            }).catch((error) => {
                console.error('Error loading ledger data:', error);
                this.setState({ loading: false });
            });

                this.props.getMachineServicesById(data.key).then((result) => {
                this.setState({
                    machineServices: result,
                    loading: false,
                })
            }).catch((error) => {
                console.error('Error loading services data:', error);
                this.setState({ servicesLoading: false });
            });
    
    }

    handleRemoveClick = () => {
        this.props.history.push("/report?name=MachineTracker")
    }

    renderCustomHeader = () => {
        const { machineData } = this.state;

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                // alignItems: 'center',
                width: '100%',
                padding: '0px 16px',
            }}>
                {/* Left side - Product Image and Details */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    {/* Product Image */}
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: '#f3f4f6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #e5e7eb'
                    }}>
                        <img
                            src={machineData.ProductImage || NO_IMAGE_FOUND}
                            alt={machineData.ProductName}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />

                    </div>

                    {/* Product Details */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px'
                    }}>
                        {/* Product Name */}
                        <div style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#111827'
                        }}>
                            {machineData.ProductName || 'N/A'}
                        </div>

                        {/* Product SKU */}
                        <div style={{
                            fontSize: '13px',
                            color: '#6b7280'
                        }}>
                            SKU: {machineData.ProductSKU || 'N/A'}
                        </div>

                        {/* UniqueNo1 and Status */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            marginTop: '2px'
                        }}>
                            <div style={{
                                fontSize: '13px',
                                color: '#6b7280'
                            }}>
                                Machine No: {machineData.UniqueNo1 || 'N/A'}
                            </div>
                            <span style={{
                                padding: '2px 10px',
                                borderRadius: '12px',
                                backgroundColor: '#10b981',
                                color: '#ffffff',
                                fontSize: '12px',
                                fontWeight: '500'
                            }}>
                                {machineData.Status || 'N/A'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Right side - Remove Icon */}
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '16px'
                }}>
                    <span
                        style={{
                            cursor: 'pointer',
                            color: '#6b7280',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            borderRadius: '6px',
                            transition: 'all 0.2s',
                            hover: {
                                backgroundColor: '#f3f4f6'
                            }
                        }}
                        onClick={this.handleRemoveClick}
                    >
                        <Icon type="remove" />
                    </span>
                </div>
            </div>
        );
    }

 renderLeftContent = () => {
    return (
        <CustomTable
            columns={[
                {
                    field: "Customer",
                    headerName: "Customer",
                    renderCell: ({ row }) => {
                        // Check if row has CustomerName using proper hasOwnProperty method
                        const hasCustomerName = Object.prototype.hasOwnProperty.call(row, "CustomerName");
                        const hasCustomerPhone = Object.prototype.hasOwnProperty.call(row, "CustomerPhoneNo");
                        
                        // Also check if row.CustomerName exists and is not empty
                        const customerName = row.CustomerName;
                        const customerPhone = row.CustomerPhoneNo;
                        
                        if (customerName && customerName.trim() !== '') {
                            return (
                                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                    <div style={{ fontWeight: "500" }}>
                                        {customerName}
                                    </div>
                                    {customerPhone && customerPhone.trim() !== '' && (
                                        <div style={{ color: "#6b7280", fontSize: "13px" }}>
                                            {customerPhone}
                                        </div>
                                    )}
                                </div>
                            );
                        } else {
                            return (
                                <span style={{ color: "#9ca3af", fontSize: "14px", fontStyle: "italic" }}>
                                    - N/A -
                                </span>
                            );
                        }
                    },
                },
                  {
                    field: "Date",
                    headerName: "Transaction Date",
                },
                {
                    field: "TransactionNo",
                    headerName: "Transaction No",
                },
                {
                    field: "Status",
                    headerName: "Status",
                },
                
            ]}
            showTextOnRows={this.state.machineServices.length==0 ? "No services found" :null}
            loading={this.state.loading}
            rows={this.state.machineServices}
        />
    )
}


    renderRightContent = () => {
        
      return (
        <NewAuditTrail 
   data={this.state.ledgerData} 
  loading={this.state.loading}
  leftFields={[
 { key: "Date", label: "" },
  ]}
  fields={[
    { key: "Status", label: "Status" },
    { key: "CustomerName", label: "Customer Name" },
  ]}
/>
      )
    }
 renderContent = () => {
    return (
        <ViewPage
            customHeader={this.renderCustomHeader()}
        >
            <div style={{ 
                display: 'flex', 
                width: '100%', 
                height: '100%',  // Changed from calc(100vh - 100px) to 100%
                gap: '16px',     // Added gap between columns
            }}>
                {/* Left side - 65% with independent scroll */}
                <div style={{ 
                    flex: '0 0 65%', 
                    overflowY: 'auto',  // Changed from overflow to overflowY
                    height: '100%',     // Added height: 100%
                    paddingRight: '8px'
                }} className='custom-scrollable'>
                    {this.renderLeftContent()}
                </div>
                
                {/* Right side - 35% with independent scroll */}
                <div style={{ 
                    flex: '1',          // Changed from flex: '0 0 45%' to flex: '1'
                    overflowY: 'auto',  // Changed from overflow to overflowY
                    height: '100%',     // Added height: 100%
                    paddingLeft: '8px',
                    borderLeft: '1px solid #e5e7eb'  // Added separator line
                }} className='custom-scrollable'>
                    {this.renderRightContent()}
                </div>
            </div>
        </ViewPage>
    )
}
    render() {

        return (
            <div className='header-margin'>
                <SideBySideLayout
                    showFullScreen={true}
                    right={this.renderContent()}
                />

            </div>
        );
    }
}

export default withRouter(MachineTrackerLedger);